import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

const getField = (source, camelCaseName, pascalCaseName) =>
  source?.[camelCaseName] ?? source?.[pascalCaseName];

export const VisitE025Details = ({ e025List, e025Ref, handleFileDownload }) => {
  if (!Array.isArray(e025List) || e025List.length === 0) return null;

  return (
    <div ref={e025Ref} className="mt-3">
      {e025List.map((e025, index) => {
        const date = getField(e025, 'date', 'Date');
        const time = getField(e025, 'time', 'Time');
        const practitioner = getField(e025, 'practitioner', 'Practitioner');
        const qualification = getField(
          practitioner,
          'qualification',
          'Qualification',
        );
        const name = getField(practitioner, 'name', 'Name');
        const surname = getField(practitioner, 'surname', 'Surname');
        const file = getField(e025, 'file', 'File');
        const fileGuid = getField(file, 'guid', 'Guid');
        const fileType = getField(file, 'type', 'Type');
        const complaints = getField(e025, 'complaints', 'Complaints');
        const objectiveCondition = getField(
          e025,
          'objectiveCondition',
          'ObjectiveCondition',
        );
        const finishedDiagnosticReports = getField(
          e025,
          'finishedDiagnosticReports',
          'FinishedDiagnosticReports',
        );
        const plannedDiagnosticReports = getField(
          e025,
          'plannedDiagnosticReports',
          'PlannedDiagnosticReports',
        );
        const carePlan = getField(e025, 'carePlan', 'CarePlan');
        const medicationStatement = getField(
          e025,
          'medicationStatement',
          'MedicationStatement',
        );
        const recommendations = getField(
          e025,
          'recommendations',
          'Recommendations',
        );

        return (
          <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">
              Ambulatorinio apsilankymo aprašymas
            </Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(date)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(date)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(date)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Laikas: </span>
              <Moment utc parse="HH:mm" format="HH:mm">
                {time}
              </Moment>
            </div>

            <div>
              <span>Gydytojas: </span>
              <span>
                {qualification} - {name} {surname}
              </span>
            </div>

            <div>
              <span>Nusiskundimai ir anamnezė: </span>
              {complaints?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            <div>
              <span>Objektyvi būklė: </span>
              {objectiveCondition?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            <div>
              <span>Atlikti tyrimai ir konsultacijos: </span>
              {finishedDiagnosticReports
                ?.split(/;|\r?\n|<br\/>/)
                .map((text, i) => (
                  <span key={i}>{text}</span>
                ))}
            </div>

            <div>
              <span>Tyrimų ir konsultacijų planas: </span>
              {plannedDiagnosticReports
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => (
                  <span key={i}>{text}</span>
                ))}
            </div>

            <div>
              <span>Taikytas gydymas: </span>
              {carePlan
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => <span key={i}>{text}</span>) || <br />}
            </div>

            <div>
              <span>Taikytas medikamentinis gydymas: </span>
              {medicationStatement
                ?.split(/\r?\n|<br\/>/)
                .map((text, i) => <span key={i}>{text}</span>) || <br />}
            </div>

            <div>
              <span>Rekomendacijos: </span>
              {recommendations?.split(/\r?\n|<br\/>/).map((text, i) => (
                <span key={i}>{text}</span>
              ))}
            </div>

            {fileGuid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${qualification}-${name} ${surname} ${moment(date).format(
                      'YYYY-MM-DD',
                    )}`;
                    handleFileDownload(
                      'e025',
                      fileName,
                      fileType,
                      fileGuid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
        );
      })}
    </div>
  );
};
